import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { COMPANY_EMPLOYEES_COUNT, DEFAULT_COMPANY_EMPLOYEES_COUNT, DEFAULT_EMAIL_VERIFICATION_TYPES, DEFAULT_SENIORIRT_TYPES, EMAIL_VERIFICATION_TYPES, EMITTER_ERROR, EMITTER_SUCCESS, SENIORIRT_TYPES, tempHeadCompanyCells } from "../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { allFilters, filterHeaderCompanyCity, filterHeaderCompanyCountry, filterHeaderCompanyKeywords, filterHeaderCompanyName, filterHeaderCompanySeo, filterHeaderCompanyState, filterHeaderCompanyTechnologies, filterHeaderEmailVerification, filterHeaderPersonCity, filterHeaderPersonCountry, filterHeaderPersonState, filterHeaderSearchCompany, filterHeaderSearchIndustry, filterHeaderSearchJobTitle, filterHeaderSearchSeniority } from "../../../redux/actions/filterActions";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { AddViewModal, AllViewModal } from ".";
import { getRequest, postRequest } from "../../../Apis";
import { leadsEndpoints, viewEndPoints } from "../../../utils/constants/httpConstants";
import EventEmitter from "../../../utils/emitter/EventEmitter";
import { filterQuery, getSelectedColumns } from "../../../utils/helpers";
import { filterHeaderIndustry, filterHeaderJobTitle, initialFilterPayload, initialQueryPayload, stringQueryList } from "../../../redux/store/storeConstants";
import { checkExistFields, getCheckEmployeeCount, getSelectedSeniority } from "../../../redux/store/storeHelper";
import { filterKeys } from "../../../utils/constants/filters";
import { getCompanyBasicDetails } from "../../../redux/actions/companyActions";
import { applyUpdateColumn, updateColumnHeaders } from "../../../redux/actions/tableActions";
import { Button } from "../../../components/Buttons";
import { STRINGS } from "../strings";
import { ICON_LABELS, fontSize, fontWeight } from "../../../utils/constants/UI";
import ViewTab from "../../../components/ViewTab/ViewTab";
import CustomStyledMenu from "../../../components/Menu/CustomStyledMenu";
import IconComponent from "../../../components/Icon/IconComponent";
import TypographyInline from "../../../components/Typography/TypographyInline";
import { GREY } from "../../../utils/constants/colors";
import classes from "./LeadsComponent.module.css";


const CompanyHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.companyBasicDetails);

  const selectedTableCells = useSelector(
    (state) => state?.columnUpdate?.columns
  );
  const allFiltersSelector = useSelector((state) => state?.allFilters);
  const { loading, payload, error } = selector;

  const [showAllViewsModal, setShowAllViewsModal] = useState(false);
  const [openAddView, setOpenAddView] = useState(false);

  const [showViewActions, setShowViewActions] = useState("");
  const [actionPerforming, setActionPerforming] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [defaultQueryPushed, setDefaultQueryPushed] = useState(false);
  const [actionValue, setActionValue] = useState("");
  const [saveViewEL, setSaveViewEL] = useState(null);
  const [viewEL, setViewEL] = useState(null);
  const [spViewEL, setSpViewEL] = useState(null);
  const [viewClicked, setViewClicked] = useState({});
  const [viewType, setViewType] = useState("")

  const handleSaveView = async () => {
    const filteredQuery = filterQuery(allFiltersSelector?.payload);
    const SelectedTableIds = getSelectedColumns(
      selectedTableCells?.filter((item) => item?.companyField)
    );
    const viewPayload = {
      query_string: filteredQuery,
      view_id: payload?.active_view?.view_id,
      table_columns: SelectedTableIds,
    };
    try {
      setActionPerforming(true);
      const response = await postRequest(
        navigate,
        viewEndPoints?.updateView,
        viewPayload
      );
      if (response?.status === 200) {
        EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
        setActionPerforming(false);
      }
    } catch (error) {
      setActionPerforming(false);
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    } finally {
      setSaveViewEL(null);
    }
  };

  const saveViewModal = (
    <div className={classes.sortingModal}>
      <div className={classes.containSaveText}>
        <TypographyInline
          label={STRINGS.SAVE_AS_CURRENT}
          size={"md"}
          fontWeight={fontWeight.MEDIUM}
          color={GREY.PRIMARY}
        />
      </div>
      <div className={classes.saveViewDisplayTxt}>
        <TypographyInline
          size={"sm"}
          fontWeight={fontWeight.REGULAR}
          color={GREY.SECONDARY}
          label={STRINGS.SAVE_TEXT}
        />
      </div>
      <div className={classes.containApplyBtn}>
        <div>
          <Button
            label={STRINGS.SAVE_AS_NEW}
            LeftIcon={ICON_LABELS.ADD}
            size={"sm36"}
            variant={"text"}
            onClick={() => {
              setOpenAddView(true);
              setSaveViewEL(null)
            }}
          />
        </div>
        <div className={classes.rightFooterButton}>
          <Button
            label={STRINGS.CANCEL}
            size={"sm36"}
            variant={"ghost"}
            onClick={() => setSaveViewEL(null)}
          />
          <Button
            label={STRINGS.SAVE}
            size={"sm36"}
            disabled={payload?.active_view?.view_name === STRINGS.ALL_COMPANIES}

            variant={"primary"}
            onClick={handleSaveView}
            isLoading={actionPerforming}
          />
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const active_view_id = sessionStorage.getItem(STRINGS.ACTIVE_VIEW_ID
    );

    if (!mounted) {
      setMounted(true);
      dispatch(
        getCompanyBasicDetails(
          navigate,
          active_view_id ? `?${STRINGS.VIEW_ID}=${active_view_id}` : ""
        )
      );
    }
    if (
      Object.keys(payload?.default_view || {}).length &&
      !defaultQueryPushed
    ) {
      const filters = filterQuery(allFiltersSelector?.payload);
      let query_string;

      if (active_view_id) {


        if (active_view_id === payload?.default_view?.view_id) {
          query_string = filters;
        } else {
          query_string = payload?.active_view?.query_string || {};
        }
      } else {
        if (payload?.default_view?.is_main_view) {
          query_string = filters;
        } else {
          query_string = payload?.default_view?.query_string;
        }
      }

      const table_columns = payload?.default_view?.is_main_view
        ? payload?.active_view?.table_columns
        : payload?.active_view?.table_columns || [];

      handleChangeView(query_string, table_columns);
      setDefaultQueryPushed(true);
    }
  }, [allFiltersSelector, dispatch, error, navigate, payload, mounted]);

  const handleClearAllFilter = async () => {
    // for company name filter

    dispatch(
      filterHeaderSearchCompany(
        JSON.parse(JSON.stringify(DEFAULT_COMPANY_EMPLOYEES_COUNT))
      )
    );
    dispatch(
      filterHeaderSearchSeniority(
        JSON.parse(JSON.stringify(DEFAULT_SENIORIRT_TYPES))
      )
    );
    dispatch(
      filterHeaderEmailVerification(
        JSON.parse(JSON.stringify(DEFAULT_EMAIL_VERIFICATION_TYPES))
      )
    );
    dispatch(filterHeaderSearchJobTitle(initialFilterPayload));
    dispatch(filterHeaderSearchIndustry(initialFilterPayload));
    dispatch(filterHeaderCompanyKeywords(initialFilterPayload));
    dispatch(filterHeaderCompanyTechnologies(initialFilterPayload));
    dispatch(filterHeaderCompanySeo(initialFilterPayload));
    dispatch(filterHeaderPersonCity(initialFilterPayload));
    dispatch(filterHeaderPersonState(initialFilterPayload));
    dispatch(filterHeaderPersonCountry(initialFilterPayload));
    dispatch(filterHeaderCompanyCity(initialFilterPayload));
    dispatch(filterHeaderCompanyState(initialFilterPayload));
    dispatch(filterHeaderCompanyCountry(initialFilterPayload));
    dispatch(filterHeaderCompanyName(initialFilterPayload));
    dispatch(allFilters(initialQueryPayload, true));
    navigate({
      pathname: location.pathname,
      search: createSearchParams(initialQueryPayload).toString(),
    });
  };

  const handleChangeView = async (query, table_columns) => {
    handleClearAllFilter();
    if (!table_columns.length) {
      table_columns = [
        ...tempHeadCompanyCells
          .filter((item) => item.isChecked)
          .map((item) => item.id),
      ];
    }

    const new_table_cells_payload = [];
    for (let i in tempHeadCompanyCells) {
      if (table_columns.includes(tempHeadCompanyCells[i].id)) {
        new_table_cells_payload.push({ ...tempHeadCompanyCells[i], isChecked: true });
      } else {
        new_table_cells_payload.push({ ...tempHeadCompanyCells[i], isChecked: false });
      }
    }
    await dispatch(applyUpdateColumn(new_table_cells_payload));
    await dispatch(updateColumnHeaders(new_table_cells_payload));

    const res = query;
    if (res) {
      for (let i in res) {
        if (
          typeof res[i] === STRINGS.STRING &&
          stringQueryList?.indexOf(i) === -1
        ) {
          res[i] = [res[i]];
        }
      }
    }

    const filterHeaderSeniority = {
      payload: res?.seniority
        ? getSelectedSeniority(SENIORIRT_TYPES, res?.seniority)
        : SENIORIRT_TYPES,
    };

    const filterHeaderCompany = {
      payload: res.employee_number
        ? getCheckEmployeeCount(
          JSON.parse(JSON.stringify(COMPANY_EMPLOYEES_COUNT)),
          res.employee_number
        )
        : JSON.parse(JSON.stringify(COMPANY_EMPLOYEES_COUNT)),
    };

    const initalJobTitleSelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.job_title?.length ||
        res?.job_title_not?.length
        ? checkExistFields(res, filterKeys.job_title)
        : JSON.parse(JSON.stringify(filterHeaderJobTitle));

    const initalIndustrySelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.industry?.length ||
        res?.industry_not?.length
        ? checkExistFields(res, filterKeys.industry)
        : JSON.parse(JSON.stringify(filterHeaderIndustry));

    const InitialEmailVerification = {
      payload: res?.email_verification
        ? getCheckEmployeeCount(
          EMAIL_VERIFICATION_TYPES,
          res?.email_verification
        )
        : EMAIL_VERIFICATION_TYPES,
    };

    const initalCompanyKeywordsSelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.company_keywords?.length ||
        res?.company_keywords_not?.length
        ? checkExistFields(res, STRINGS.COMPANY_KEYWORDS)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalCompanyTechnologySelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.company_technologies?.length ||
        res?.company_technologies_not?.length ||
        res?.company_technologies_all?.length
        ? checkExistFields(res, STRINGS.COMPANY_TECHNOLOGIES)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalCompanySeoSelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.seo_description?.length ||
        res?.seo_description_not?.length ||
        res?.seo_description_all?.length
        ? checkExistFields(res, STRINGS.SEO_DESCRIPTION)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalCompanyCitySelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.company_city?.length ||
        res?.company_city_not?.length
        ? checkExistFields(res, STRINGS.COMPANY_CITY)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalCompanyStateSelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.company_state?.length ||
        res?.company_state_not?.length
        ? checkExistFields(res, STRINGS.COMPANY_STATE)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initialCompanyNameSelect = res?.exist_fields?.length ||
      res?.not_exist_fields?.length ||
      res?.company_ids?.length ||
      res?.company_ids_not?.length
      ? checkExistFields(res, STRINGS.COMPANY_NAME)
      : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalCompanyCountrySelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.company_country?.length ||
        res?.company_country_not?.length
        ? checkExistFields(res, STRINGS.COMPANY_COUNTRY)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalPersonCitySelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.person_city?.length ||
        res?.person_city_not?.length
        ? checkExistFields(res, STRINGS.PERSON_CITY)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalPersonStateSelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.person_state?.length ||
        res?.person_state_not?.length
        ? checkExistFields(res, STRINGS.PERSON_STATE)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    const initalPersonCountrySelect =
      res?.exist_fields?.length ||
        res?.not_exist_fields?.length ||
        res?.person_country?.length ||
        res?.person_country_not?.length
        ? checkExistFields(res, STRINGS.PERSON_COUNTRY)
        : JSON.parse(JSON.stringify(initialFilterPayload));

    dispatch(
      filterHeaderSearchCompany(
        JSON.parse(JSON.stringify(filterHeaderCompany?.payload))
      )
    );
    dispatch(
      filterHeaderSearchSeniority(
        JSON.parse(JSON.stringify(filterHeaderSeniority?.payload))
      )
    );
    dispatch(
      filterHeaderEmailVerification(
        JSON.parse(JSON.stringify(InitialEmailVerification?.payload))
      )
    );
    dispatch(filterHeaderSearchJobTitle(initalJobTitleSelect?.payload));
    dispatch(filterHeaderSearchIndustry(initalIndustrySelect?.payload));
    dispatch(filterHeaderCompanyKeywords(initalCompanyKeywordsSelect?.payload));
    dispatch(
      filterHeaderCompanyTechnologies(initalCompanyTechnologySelect?.payload)
    );
    dispatch(filterHeaderCompanySeo(initalCompanySeoSelect?.payload));
    dispatch(filterHeaderPersonCity(initalPersonCitySelect?.payload));
    dispatch(filterHeaderPersonState(initalPersonStateSelect?.payload));
    dispatch(filterHeaderPersonCountry(initalPersonCountrySelect?.payload));
    dispatch(filterHeaderCompanyCity(initalCompanyCitySelect?.payload));
    dispatch(filterHeaderCompanyState(initalCompanyStateSelect?.payload));
    dispatch(filterHeaderCompanyCountry(initalCompanyCountrySelect?.payload));
    dispatch(filterHeaderCompanyName(initialCompanyNameSelect?.payload));
    dispatch(allFilters(query));
    navigate({
      pathname: location.pathname,
      search: createSearchParams(query || {}).toString(),
    });
  };

  const handleUnpinView = async () => {
    try {
      setActionPerforming(true);
      setActionValue(STRINGS.UNPIN_THIS_VIEW);
      setViewEL(null);
      setSpViewEL(null);
      const response = await getRequest(
        navigate,
        viewEndPoints?.unpinCompanyView + `?${STRINGS.VIEW_ID}=` + showViewActions
      );
      const active_view_id = sessionStorage.getItem(STRINGS.ACTIVE_VIEW_ID);

      if (response?.status === 200) {
        EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
        await dispatch(getCompanyBasicDetails(navigate, active_view_id
          ? `?${STRINGS.VIEW_ID}=${active_view_id}`
          : payload?.default_view?.is_main_view
            ? `?${STRINGS.VIEW_ID}=${payload?.default_view?.view_id}`
            : payload?.default_view?.view_id
              ? `?${STRINGS.VIEW_ID}=${payload?.default_view?.view_id}`
              : ""));
        setActionPerforming(false);
      }
    } catch (error) {
      setActionPerforming(false);
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    }
  };

  const handleMakeDefaultView = async () => {
    try {
      setActionPerforming(true);
      setActionValue(STRINGS.MAKE_DEFAULT_VIEW);
      setViewEL(null);
      const response = await getRequest(
        navigate,
        viewEndPoints?.makeCompanyDefaultView + `?${STRINGS.VIEW_ID}=` + showViewActions
      );
      if (response?.status === 200) {
        EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
        try {
          const response = await getRequest(
            navigate,
            leadsEndpoints.companyBasic
          );
          await dispatch(getCompanyBasicDetails(navigate));
          handleChangeView(
            response?.data?.data?.default_view?.query_string || {},
            response?.data?.data?.default_view?.table_columns
          );
          setActionPerforming(false);
        } catch (err) {
          setActionPerforming(false);
        }
      }
    } catch (error) {
      setActionPerforming(false);
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    }
  };

  const handleChangeActiveView = async (view) => {
    try {
      const response = await getRequest(
        navigate,
        leadsEndpoints.companyBasic + `?${STRINGS.VIEW_ID}=${view.view_id}`
      );
      sessionStorage.setItem(STRINGS.ACTIVE_VIEW_ID
        , view?.view_id.toString());

      await dispatch(
        getCompanyBasicDetails(navigate, true, response?.data?.data)
      );
      handleChangeView(
        response?.data?.data?.active_view?.query_string || {},
        response?.data?.data?.active_view?.table_columns
      );
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    }
  };

  const handlePinView = async () => {
    try {
      const View = payload?.active_view;
      setActionPerforming(true);
      setActionValue(STRINGS.PIN_THIS_VIEW);
      setViewEL(null);
      setSpViewEL(null);
      const response = await getRequest(
        navigate,
        viewEndPoints.pinCompanyView + `?${STRINGS.VIEW_ID}=` + View?.view_id
      );
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
      handleChangeActiveView(View);
      setActionPerforming(false);
    } catch (error) {
      setActionPerforming(false);
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    }
  };

  const viewsActionList = [
    {
      type: STRINGS.UNPIN_THIS_VIEW,
      action: handleUnpinView,
      icon: ICON_LABELS.PUSH_PIN,
      inPinnedList: true,
    },
    {
      type: STRINGS.MAKE_DEFAULT_VIEW,
      action: handleMakeDefaultView,
      icon: ICON_LABELS.BOOKMARK,
      inPinnedList: true,
    },
    {
      type: STRINGS.PIN_THIS_VIEW,
      action: handlePinView,
      icon: ICON_LABELS.PUSH_PIN,
      inPinnedList: false,
    },
  ];

  const handleViewActionChange = (id) => {
    setShowViewActions(id);
  };

  const handleDefaultViewClick = async () => {

    try {
      const response = await getRequest(
        navigate,
        leadsEndpoints.companyBasic +
        `?${STRINGS.VIEW_ID}=${payload?.default_view?.view_id}`
      );
      sessionStorage.setItem(STRINGS.ACTIVE_VIEW_ID
        , payload?.default_view?.view_id);

      await dispatch(
        getCompanyBasicDetails(navigate, true, response?.data?.data)
      );
      handleChangeView(
        response?.data?.data?.active_view?.query_string || {},
        response?.data?.data?.active_view?.table_columns
      );
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    }
  };

  const viewTabIconHandler = (e, view) => {
    if (viewEL) {
      setViewEL(null);
      setViewClicked({});
    } else {
      setViewEL(e?.currentTarget);
      setViewClicked(view);
    }
    handleViewActionChange(view?.view_id);
  };

  const specialViewTabIconHandler = (e, view) => {
    if (spViewEL) {
      setSpViewEL(null);
    } else {
      setSpViewEL(e?.currentTarget);
    }
    handleViewActionChange(view?.view_id);
  };

  return (
    <Box className={classes.container} >
      {/* Default View  */}
      <Box className={classes.viewContainer}>
        <Box className={classes.peopleContainer}>
          {/* Default View  */}
          <div>
            <ViewTab
              tabLabel={
                loading ? STRINGS.LOADING : payload?.default_view?.view_name
              }
              isActive={
                payload?.default_view?.view_id === payload?.active_view?.view_id
              }
              isDefault
              RightIcon={ICON_LABELS.ACTION_ARROW}
              buttonClick={
                payload?.default_view?.view_id !== payload?.active_view?.view_id
                  ? () => handleDefaultViewClick()
                  : null
              }
            />
          </div>
          {/* Default View  */}
          {/* Pinned View */}
          {payload?.pinned_view?.map((view, index) => {
            return (
              <>
                <div>
                  <ViewTab
                    RightIcon={ICON_LABELS.ACTION_ARROW}
                    tabLabel={view?.view_name}
                    buttonClick={() => handleChangeActiveView(view)}
                    isPin
                    iconClick={(e) => {
                      viewTabIconHandler(e, view);
                    }}
                    isActive={view?.view_id === payload?.active_view?.view_id}
                  />
                </div>

              </>
            );
          })}
          <CustomStyledMenu
            anchorEl={viewEL}
            open={Boolean(viewEL)}
            onClose={() => setViewEL(null)}
            marginTop={"2px !important"}
            // noMargin={true}
            width={"13vw"}
          // arrow
          >
            <Box className={classes.pinnedViewActions}>
              {showViewActions === viewClicked?.view_id && (
                <Box
                  onClick={() => handleViewActionChange(viewClicked?.view_id)}
                >
                  {viewsActionList?.map((action, index) => {
                    return viewClicked?.is_main_view &&
                      action.type === STRINGS.UNPIN_THIS_VIEW
                      ? null
                      : action.inPinnedList && (
                        <Box
                          key={action.type}
                          onClick={() => action.action()}
                          className={
                            viewsActionList?.length - 1 === index
                              ? classes.borderFlex1
                              : classes.borderFlex1
                          }
                        >
                          <IconComponent
                            color={GREY.TERTIARY}
                            fontSize={fontSize.MD}
                            iconLabel={action.icon}
                          />
                          <TypographyInline
                            label={
                              actionValue === action.type && actionPerforming
                                ? STRINGS.LOADING1
                                : action.type
                            }
                            size={"sm"}
                            fontWeight={fontWeight.REGULAR}
                            color={GREY.SECONDARY}
                          />
                        </Box>
                      );
                  })}
                </Box>
              )}
            </Box>
          </CustomStyledMenu>

          {/* Special Case */}
          {!payload?.active_view?.is_main_view &&
            payload?.active_view?.temp_active_view &&
            payload?.default_view?.view_id !== payload?.active_view?.view_id &&
            !payload?.pinned_view?.filter(
              (view) => view?.view_id === payload?.active_view?.view_id
            ).length ? (
            <div>
              <ViewTab
                RightIcon={ICON_LABELS.ACTION_ARROW}
                tabLabel={payload?.active_view?.view_name}
                buttonClick={() => handleChangeActiveView(payload?.active_view)}
                iconClick={(e) => {
                  specialViewTabIconHandler(e, payload?.active_view);
                }}
                isActive
              />
            </div>
          ) : null}
          <CustomStyledMenu
            anchorEl={spViewEL}
            open={Boolean(spViewEL)}
            onClose={() => setSpViewEL(null)}
            marginTop={"2px !important"}
            // noMargin={true}
            width={"13vw"}
          // arrow
          >
            <Box className={classes.pinnedViewActions}>
              {showViewActions === payload?.active_view?.view_id && (
                <Box
                  onClick={() =>
                    handleViewActionChange(payload?.active_view?.view_id)
                  }
                >
                  {viewsActionList?.map((action, index) => {
                    return (
                      !action.inPinnedList && (
                        <Box
                          key={action.type}
                          onClick={() => action.action()}
                          className={
                            viewsActionList?.length - 1 === index
                              ? classes.borderFlex1
                              : classes.borderFlex1
                          }
                        >
                          <IconComponent
                            color={GREY.TERTIARY}
                            fontSize={fontSize.MD}
                            iconLabel={action.icon}
                          />
                          <TypographyInline
                            label={
                              actionValue === action.type && actionPerforming
                                ? STRINGS.LOADING1
                                : action.type
                            }
                            size={"sm"}
                            fontWeight={fontWeight.REGULAR}
                            color={GREY.SECONDARY}
                          />
                        </Box>
                      )
                    );
                  })}
                </Box>
              )}
            </Box>
          </CustomStyledMenu>
          {/* Special Case */}

          {/* Manage View Button */}
          <div className={classes.manage}>
            <Button
              label={STRINGS.MANAGE_VIEWS}
              LeftIcon={ICON_LABELS.CLEAR_ALL}
              size={"sm36"}
              variant={"text"}
              onClick={() => setShowAllViewsModal(!showAllViewsModal)}
            /></div>

        </Box>
        <Box className={classes.actionContainer}>
          <div className={classes.saveViewButton}>
            <Button
              LeftIcon={ICON_LABELS.SAVE}
              label={STRINGS.SAVE_VIEW}
              size={"sm36"}
              variant={"ghost"}
              onClick={(e) => setSaveViewEL(e.currentTarget)}
            />
          </div>

          {/* Add View Modal */}
          {openAddView &&
            <AddViewModal
              leadType={STRINGS.SINGLE_COMPANY}
              open={openAddView}
              setOpen={setOpenAddView}
              viewType={viewType}
            />
          }

          {/* All Views Modal */}
          <AllViewModal
            open={showAllViewsModal}
            setOpen={setShowAllViewsModal}
            leadType={STRINGS.SINGLE_COMPANY}
            setOpenAddView={setOpenAddView}
            setViewType={setViewType}
            viewType={viewType}
          />



          {/* Save View Content Here(button with Menu) */}
          <CustomStyledMenu
            open={Boolean(saveViewEL)}
            anchorEl={saveViewEL}
            onClose={() => setSaveViewEL(null)}
            noMargin={true}
            width="21vw"
          >
            {saveViewModal}
          </CustomStyledMenu>

        </Box>
      </Box>
    </Box>
  );
};

export default React.memo(CompanyHeader);
